import _ from "lodash";

/**
 * convert css attribute to react style
 * eg. background-color -> backgroundColor
 *
 * @param {string} attr
 */
export function toReact(attr) {
  if (attr.includes("-")) {
    const tokens = attr.split("-");
    const capitalized = tokens
      .slice(1)
      .map((f) => f[0].toUpperCase() + f.slice(1));
    return [tokens[0], ...capitalized].join("");
  }
  return attr;
}

/**
 * convert react attribute to regular css
 * eg. backgroundColor -> background-color
 *
 * @param {string} attr
 */
export function fromReact(attr) {
  if (attr.toLowerCase() !== attr) {
    const tokens = [];
    let idx = 0;
    for (let i in attr) {
      if (attr[i] === attr[i].toUpperCase()) {
        tokens.push(attr.slice(idx, i).toLowerCase());
        idx = i;
      }
    }
    tokens.push(attr.slice(idx).toLowerCase());
    return tokens.join("-");
  }
  return attr;
}

export function toReactStyles(styles) {
  return _.mapKeys(styles, (v, k) => toReact(k));
}
